import InvoiceNumber from '../InvoiceNumber'
import { PurchaseOrderTargetType } from '../../../../../../../graphql'

export type OrderTargetProps = {
	targetType?: PurchaseOrderTargetType | null,
	targetId?: number | null,
}

export default function OrderTarget( { targetType, targetId }: OrderTargetProps ) {
	if ( !targetType ) {
		return null
	}
	switch ( targetType ) {
		case PurchaseOrderTargetType.WorkOrder:
			return <span>WO-{targetId}</span>
		case PurchaseOrderTargetType.Invoice:
			return <InvoiceNumber targetId={targetId ?? 0} />
		case PurchaseOrderTargetType.Order:
			return <span>ORD-{targetId}</span>
		case PurchaseOrderTargetType.Stock:
			return <span>Stock</span>
		default:
			return <span>{targetId}</span>
	}
}
